import * as fetch from 'isomorphic-fetch';
import * as utils from './utils';
import { queryList } from './config'

interface IOptions {
  url: string;
  method?: string;
  data?: any;
  headers?: any;
  mode?: string;
  shopDomain?: string;
};

function navigateToLogin() {
  const querys = {
    returnUrl: utils.getQueryString('returnUrl') || ''
  }
  let q = ''

   const findValue = queryList.find(v => window.location.href.indexOf(v.url) > -1)
    if (findValue) {
      findValue.list.forEach((v2: any) => {
        for(let key in v2) {
          querys[key] = v2[key]
        }
      })
    }

    for(let key in querys) {
       q += '&' + key + '=' + querys[key]
     }
     q = q.substr(1)

     window.location.replace('/mobile/uc/build/login?' + q);
}

function isPhpProject(url: string) {
  return url.indexOf('cn') > -1 || url.indexOf('ylcool') > -1
}

const request = async (options: IOptions, useJsonData?: Boolean) => {
  let dataTemp: any = '';
  if(options.method && typeof options.method === 'string' && options.method.toLowerCase() === 'post') {
      if (useJsonData) {
        dataTemp = options.data
        if (isPhpProject(options.url)) {
           dataTemp.api_token = utils.getCookie('CMALL_TOKEN')
        }
        dataTemp = JSON.stringify(dataTemp)
      } else {
        if (isPhpProject(options.url)) {
          dataTemp = `api_token=${utils.getCookie('CMALL_TOKEN')}&`
        }
        if(typeof options.data === 'string') {
          dataTemp += options.data;
        } else if (options.data) {
          for(const item of Object.keys(options.data)) {
            if (Object.prototype.toString.call(options.data[item]) === '[object Array]') {
              for(let i=0,l=options.data[item].length; i<l; i++) {
                dataTemp += `${item}[${i}]=${options.data[item][i]}&`;
              }
            } else {
              dataTemp += `${item}=${options.data[item]}&`;
            }
            
          }
          dataTemp = dataTemp.substring(0, dataTemp.length-1);
        }
      }
    
    try {
      const r: any = await fetch(options.url, {
        body: dataTemp,
        credentials: 'include',
        headers: options.headers || {
          'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
          'X-Requested-With': 'XMLHttpRequest',
          'CMALL_TOKEN': utils.getCookie('CMALL_TOKEN')
        },
        method: 'POST',
        mode: 'cors'
      }).then(response => response.json());
      // 如果没有登录
      if(r.code === 100 || r.error_code === 57000 || r.error_code === 10002) {
        navigateToLogin()
      }
      else {
        return r;
      }
    } catch(err) {
      console.log(err);
      return {};
    }

  } else {
    if(options.data) {
      dataTemp = (options.url.indexOf('?') === -1 ? '?' : '&');
      if (isPhpProject(options.url)) {
        dataTemp += `api_token=${utils.getCookie('CMALL_TOKEN')}&`
      }
      for(const item of Object.keys(options.data)) {
        dataTemp += `${item}=${options.data[item]}&`;
      }
      dataTemp = dataTemp.substring(0, dataTemp.length-1);
    } else {
      dataTemp = (options.url.indexOf('?') === -1 ? '?' : '&') + (isPhpProject(options.url) ? `api_token=${utils.getCookie('CMALL_TOKEN')}` : '')
    }
    try {
      const r: any = await fetch(options.url + dataTemp, {
        credentials: "include",
        mode: 'cors',
        headers: options.headers || {
          'X-Requested-With': 'XMLHttpRequest',
          'CMALL_TOKEN': utils.getCookie('CMALL_TOKEN')
        },
      }).then(response => response.json());
      if(r.code === 100 || r.error_code === 57000 || r.error_code === 10002) {
        navigateToLogin()
      } else {
        return r;
      }
    } catch(err) {
      console.log(err);
      return {};
    }
  }
}

export default request;
